import { ColumnFilters } from "src/app/common/column-filters";
import { Component, OnInit, inject, viewChild, signal } from "@angular/core";
import { BookingsService } from '../../services/bookings.service';
import { Blog } from '../../models/blog';
import { ConfirmationService, SelectItem, PrimeTemplate } from 'primeng/api';
import { CategoryService } from '../../services/categories.service';
import { Category } from '../../models/category';
import { MessageService } from 'primeng/api';
import { Clients } from 'src/app/models/clients';
import { ClientsService } from 'src/app/services/clients.service';
import { ComuniService } from 'src/app/services/comuni.service';
import { Comuni } from 'src/app/models/comuni';
import { WorksService } from 'src/app/services/works.service';
import { Works } from 'src/app/models/works';
import { LocationsService } from 'src/app/services/locations.service';
import { Locations } from 'src/app/models/locations';
import { Employees } from 'src/app/models/employees';
import { EmployeesService } from 'src/app/services/employees.service';
import { Bookings } from 'src/app/models/bookings';
import { formatDate, DatePipe } from '@angular/common';
import jsPDF from "jspdf";
import "jspdf-autotable";
import { TimesheetsService } from 'src/app/services/timesheets.service';
import { Rooms } from 'src/app/models/rooms';
import { Brand } from 'src/app/models/brand';
import { BrandService } from 'src/app/services/brands.service';
import { STATUS_ROOMS, TIMESHEETS_TYPE } from '../../constants/constants';
import { Table, TableModule } from 'primeng/table';
import { NgxSpinnerService } from "ngx-spinner";
import { TagsService } from 'src/app/services/tags.service';
import { Tags } from 'src/app/models/tags';
import { KeyValue } from '@angular/common';
import { Technical_data } from 'src/app/models/technical_data';
import { TechnicalDataService } from 'src/app/services/technical_data.service';
import 'moment/locale/it'
import { Timesheets } from 'src/app/models/timesheets';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { Projects } from 'src/app/models/projects';
import { UntypedFormBuilder, Validators, UntypedFormGroup, FormArray, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { Bind } from 'primeng/bind';
import { Drawer } from 'primeng/drawer';
import { DatePicker } from 'primeng/datepicker';
import { Select } from 'primeng/select';
import { ButtonDirective } from 'primeng/button';
import { TopNavComponent } from '../../top-nav/top-nav.component';
import { Card } from 'primeng/card';
import { Tag } from 'primeng/tag';
import { NgxPaginationModule } from 'ngx-pagination';
import { InputText } from 'primeng/inputtext';
import { ConfirmDialog } from 'primeng/confirmdialog';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
    standalone: true,
    selector: 'app-employees-timesheets',
    templateUrl: './employees-timesheets.component.html',
    imports: [Bind, Drawer, PrimeTemplate, DatePicker, FormsModule, Select, ButtonDirective, TopNavComponent, RouterLink, Card, TableModule, Tag, NgxPaginationModule, ReactiveFormsModule, InputText, ConfirmDialog, DatePipe, TranslatePipe]
})

export class EmployeesTimesheetsComponent extends ColumnFilters implements OnInit {
  private clientsService = inject(ClientsService);
  private timesheetsService = inject(TimesheetsService);
  private locationsService = inject(LocationsService);
  private messageService = inject(MessageService);
  private fb = inject(UntypedFormBuilder);
  private employeesService = inject(EmployeesService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private comuniService = inject(ComuniService);
  private brandService = inject(BrandService);
  private tagsService = inject(TagsService);
  private technicalDataService = inject(TechnicalDataService);
  private spinner = inject(NgxSpinnerService);
  private categoryService = inject(CategoryService);
  private confirmationService = inject(ConfirmationService);

  blogs: Blog;
  blog: Blog;
  readonly error = signal<string>(undefined);
  readonly uploadError = signal<string>(undefined);
  works: any = [];
  readonly filterSidebar = signal<boolean>(undefined);
  work: Works;
  calendarOptions: any;
  blogForm: UntypedFormGroup;
  locations: any = [];
  location: Locations;
  readonly cols = signal<any[]>(undefined);
  colsData: any[];
  readonly exportColumns = signal<any[]>(undefined);
  readonly _selectedColumns = signal<any[]>(undefined);
  selectedWorks: any[];
  selectedSkills: any[];
  readonly brands = signal<any>([]);
  brand: Brand;
  readonly tags = signal<any>([]);
  tag: Tags;
  readonly pageTitle = signal<string>(undefined);
  selectedBrands: Brand;
  loading: boolean;
  currentIndex = 1;
  readonly displayEvent = signal<any>(undefined);
  readonly timesheets_type = signal<any>(undefined);
  roomsData: any = [];
  readonly timesheets = signal<any>([]);
  readonly timesheet = signal<Timesheets>(undefined);
  date: Date;
  skillsArray: any = [];
  readonly categories = signal<any>([]);
  category: Category;
  private id: string;
  clients: any = [];
  client: Clients;
  readonly roomDialog = signal<boolean>(false);
  readonly roomDialogAdd = signal<boolean>(false);
  works_id: any;
  category_id: any;
  readonly status = signal<any>(undefined);
  currentUser: any;
  readonly technical_datas = signal<any>([]);
  technical_data: Technical_data;
  skills: any[] = [];
  batches: any[];
  projects: any = [];
  project: Projects;
  readonly vacationsCount = signal<any>(undefined);
  readonly permissionsCount = signal<any>(undefined);
  showDialog() {
    this.roomDialog.set(true);
  }

  myDate = formatDate(new Date(), 'dd/MM/yyyy', 'en');
  trackByFn(index, item) {
    return item.id;
  }
  readonly selectedTimesheetsType = signal('1');
  startDate: Date;
  bsValue: Date = new Date();
  tues = new Date();
  weekNo: number;
  readonly timesheetCountTotalEmployee = signal<Timesheets>(undefined);
  employees: any = [];
  readonly employee = signal<Employees>(undefined);
  readonly page = signal(1);
  readonly count = signal(0);
  readonly pageSize = signal(10);
  pageSizes = [5, 10, 15];
  public base_path: string;
  basePath: string;
  readonly pageOfItems = signal<Array<any>>(undefined);
  searchWrapper: boolean = false;

  public readonly dt = viewChild<Table>("dt");

  constructor() {
    super();
    this.status.set(STATUS_ROOMS);
    this.timesheets_type.set(TIMESHEETS_TYPE);

  }

  ngOnInit() {

    const dateObj = new Date();
    const yearMonth = dateObj.getUTCFullYear() + '-' + (dateObj.getUTCMonth() + 1);

    const id = this.route.snapshot.paramMap.get("id");

    this.employeesService.getId(id).subscribe((value) => {
      this.employee.set(value);
    });

    this.load();

    this.cols.set([
      { field: "date_from", header: "Da" },
      { field: "date_from", header: "A" },
      { field: "hours", header: "Ore" },
      { field: "project_id", header: "Progetto" },
    ]);
    this._selectedColumns.set(this.cols());
    this.exportColumns.set(this.cols().map(col => ({
      title: col.header,
      dataKey: col.field
    })));

    this.getVacationsCountEmployee(id);
    this.getPermissionsCountEmployee(id);

  }

  getRequestParams(searchTitle, categoryTitle, employeeTitle, page, pageSize): any {

    let path = '/admin/employee/timesheets/' + this.employees.id;
    const params = {};
    let adder = '?';
    if (page) {
      params[`page`] = page - 1;
      path += adder + 'page=' + (page - 1);
      adder = '&';
    }
    if (searchTitle) {
      params[`name`] = searchTitle;
      path += adder + 'date_from=' + searchTitle;
      adder = '&';
    }
    if (categoryTitle) {
      params[`description`] = categoryTitle;
      path += adder + 'date_to=' + categoryTitle;
      adder = '&';
    }

    if (employeeTitle) {
      params[`project_id`] = employeeTitle;
      path += adder + 'project_id=' + employeeTitle;
      adder = '&';
    }

    if (pageSize) {
      params[`size`] = pageSize;
      path += adder + 'size=' + pageSize;
    }
    window.history.replaceState({}, '', path);

    return params;

  }

  load(): void {
    const params = this.getRequestParams(
      this.filter("name"),
      this.filter("description"),
      this.filter("employee"),
      this.page(),
      this.pageSize()
    );
    this.timesheetsService.find_timesheets_employee(params, this.employees.id).subscribe((pData) => {
      this.timesheets.set(pData);
      this.count.set(this.timesheetsService.size);

      this.timesheetsService.count_total_timesheets_employee(this.employees.id).subscribe(
        (data: Timesheets) => this.timesheetCountTotalEmployee.set(data),
        error => this.error.set(error)
      );

    });
  }

  handlePageSizeChange(event): void {
    this.pageSize.set(event.target.value);
    this.page.set(1);
    this.load();
  }

  reset(): void {
    this.setFilter("name", '');
    this.setFilter("description", '');
    this.setFilter("employee", '');

    this.load();

  }

  onChangePage(pageOfItems: Array<any>) {

    this.pageOfItems.set(pageOfItems);
}

  private onChange(item: string): void {
    this.load();

  }

  public handlePageChange(event): void {
    this.page.set(event);
    this.load();

  }

  public selectionItemForFilter(e) {
    const colsTempor = e.value;
    colsTempor.sort(function (a, b) {
      return a.index - b.index;
    });
    this.cols.set([]);
    this.cols.set(colsTempor);
    if (e.value.length > 10) {
      e.value.pop();
    }
  }

  createTimesheets(employee: Employees) {
    this.roomDialogAdd.set(true);

    this.blogForm = this.fb.group({
      id: [""],
      timesheets_type: ["", Validators.required],
      date_from: ["", Validators.required],
      date_to: ["", Validators.required],
      project_id: ["", Validators.required],
      hours: ["", Validators.required],
      hours_extra: ["", Validators.required],
      employee_id: [this.employee().id],
      user_id: [this.currentUser.user_id],
    });

  }

  getVacationsCountEmployee(id) {
    const userId = this.currentUser.user_id;
    this.timesheetsService.count_total_vacations_timesheets_employee(id).subscribe(
      (data: Timesheets) => this.vacationsCount.set(data),
      error => this.error.set(error)
    );
  }

  getPermissionsCountEmployee(id) {
    const userId = this.currentUser.user_id;
    this.timesheetsService.count_total_permissions_timesheets_employee(id).subscribe(
      (data: Timesheets) => this.permissionsCount.set(data),
      error => this.error.set(error)
    );
  }

  getBrands() {
    this.brandService.getAllListbyUser().subscribe(
      (data: Brand) => this.brands.set(data),
      error => this.error.set(error)
    );
  }

  getTechnicalData() {
    this.technicalDataService.getAllListbyUser().subscribe(
      (data: Technical_data) => (this.technical_datas.set(data)),
      (error) => (this.error.set(error))
    );
  }

  clickButton(model: any) {
    this.displayEvent.set(model);

  }
  eventClick(model: any) {
    model = {
      event: {
        id: model.event.id,
        start: model.event.start,
        title: model.event.title,
        works_id: model.event.works_id.split(','),
        location_id: model.event.location_id,
        employee_id: model.event.employee_id,
        allDay: model.event.allDay,
        description: model.event.description,
        category_id: model.event.category_id

      },
      duration: {}
    }
    this.displayEvent.set(model);
    this.roomDialog.set(true);

  }

  dayClick(event) {
    console.log('dayClick', event);
  }

  getTags() {
    this.tagsService.getAllListbyUser().subscribe(
      (data: Tags) => this.tags.set(data),
      error => this.error.set(error)
    );
  }

  getCategories() {

    this.categoryService.getAllListbyUser().subscribe(
      (data: Category) => this.categories.set(data),
      error => this.error.set(error)
    );
  }

  clear(table: any) {

    table.clear();

  }

  getBrandItem(brand_id: string, id: string) {
    return this.brands().find(item => item.id === brand_id);
  }

  getProjectItem(project_id: string, id: string) {
    return this.projects.find(item => item.id === project_id);
  }

  getTechnicalDataItem(category_id: string, id: string) {
    return this.technical_datas().find(item => item.id === category_id);
  }

  getLocationItem(location_id: string, id: string) {
    return this.locations.find(item => item.id === location_id);
  }

  getTagsItem(works_id: string, id: string) {
    return this.tags().find(item => item.id === works_id);
  }

  getWorksItem(works_id: string, id: string) {
    return this.works.find(item => item.id === works_id);
  }

  editItem(timesheet: Timesheets) {
    this.timesheet.set({ ...timesheet });
    const id = timesheet.id;

    if (id) {
      this.pageTitle.set("Modifica Timesheet");
      this.timesheetsService.getId(id).subscribe((res) => {
        this.blogForm.patchValue({
          timesheets_type: res.timesheets_type,
          date_from: res.date_from,
          date_to: res.date_to,
          project_id: res.project_id,
          hours: res.hours,
          employee_id: res.employee_id,
          hours_extra: res.hours_extra,
          user_id: this.currentUser.user_id,
          id: res.id,
        });

      });
    } else {

    }

    this.blogForm = this.fb.group({
      id: [""],
      timesheets_type: ["", Validators.required],
      date_from: ["", Validators.required],
      date_to: ["", Validators.required],
      project_id: ["", Validators.required],
      hours: ["", Validators.required],
      hours_extra: ["", Validators.required],
      employee_id: [this.employee().id],
      user_id: [this.currentUser.user_id],
    });

    this.roomDialogAdd.set(true);
  }

  view(timesheet: Timesheets) {
    this.timesheet.set({ ...timesheet });

    this.roomDialog.set(true);
  }

  exportPdf() {

    const doc = new jsPDF('l', 'pt', 'A4');
    doc['autoTable'](this.exportColumns(), this.timesheets());

    doc.save('timesheet-' + this.employee().name + '-' + this.employee().surname + '.pdf');
  }

  hideDialog() {
    this.roomDialog.set(false);
  }

  onSubmit() {
    const formData = new FormData();

    formData.append("timesheets_type", this.blogForm.get("timesheets_type").value);
    formData.append("date_from", this.blogForm.get("date_from").value);
    formData.append("date_to", this.blogForm.get("date_to").value);
    formData.append('user_id', this.blogForm.get('user_id').value);
    formData.append("project_id", this.blogForm.get("project_id").value);
    formData.append("hours", this.blogForm.get("hours").value);
    formData.append("hours_extra", this.blogForm.get("hours_extra").value);
    formData.append('employee_id', this.blogForm.get('employee_id').value);

    const id = this.blogForm.get("id").value;

    if (id) {
      this.timesheetsService.update(formData, id).subscribe(
        (res) => {
          if (res.status == "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Salvato con sucesso' });
            this.roomDialogAdd.set(false);
            this.load();
            this.getVacationsCountEmployee(this.employee().id);
            this.getPermissionsCountEmployee(this.employee().id);
          }
        },
        (error) => (this.error.set(error))
      );
    } else {
      this.timesheetsService.create(formData).subscribe(
        (res) => {
          if (res.status === "error") {
            this.uploadError.set(res.message);
          } else {
            this.messageService.add({ key: 'myKey1', severity: 'success', summary: 'Informazioni', detail: 'Salvato con sucesso' });
            this.roomDialogAdd.set(false);
            this.load();
            this.getVacationsCountEmployee(id);
            this.getPermissionsCountEmployee(id);
          }
        },
        (error) => (this.error.set(error))
      );
    }

  }

  onDelete(id: string, title: string) {

    this.confirmationService.confirm({
      message: 'Sei sicuro di volerlo cancellare = ' + id,
      header: 'Confirmation',
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.timesheetsService.delete(id).subscribe(
          res => {
            console.log(res);
            this.ngOnInit();
            this.messageService.add({ key: 'myKey1', severity: 'warn', summary: 'Attenzione', detail: 'Cancellazione avvenuto con successo' });
            this.load();
          },
          error => this.error.set(error)
        );
      },

    });

  }

}
